const RecencyBadge = ({ recency, delayMinutes = 15, theme }) => {
  const delayed = recency === "delayed";
  const minutes = delayMinutes || 15;
  const label = delayed
    ? `Delayed ${minutes} min`
    : recency === "live"
      ? "Live"
      : null;
  if (!label) return null;

  return (
    <span
      className={`inline-flex max-w-full items-center rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider ${
        delayed
          ? theme === "dark"
            ? "bg-amber-500/15 text-amber-400"
            : "bg-amber-100 text-amber-700"
          : theme === "dark"
            ? "bg-emerald-500/15 text-emerald-400"
            : "bg-emerald-100 text-emerald-700"
      }`}
    >
      {label}
    </span>
  );
};

export default RecencyBadge;
